import { Component, ComponentFactoryResolver, Inject, Injector, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { combineLatest, ReplaySubject, Subscription } from 'rxjs';
import { showAnimation } from 'src/animations';
import { IOfferTransactionView } from 'src/app/lib/offer/interfaces';
import { IIssueTransactionView, ITransactionProvider, TRANSACTION_STEP_PROVIDER } from '../../../interfaces';
import { Step, STEP_FORM_GROUP } from '../../dialog/issue-transaction-dialog2/issue-transaction-dialog2-component-classes';
import { GenericTransactionSummaryInnerViewComponent } from '../generic-transaction-summary-inner-view/generic-transaction-summary-inner-view.component';

@Component({
  selector: 'app-transaction-summary-form',
  templateUrl: './transaction-summary-form.component.html',
  styleUrls: ['./transaction-summary-form.component.css'],
  animations: [ showAnimation ]
})
export class TransactionSummaryFormComponent implements IOfferTransactionView, IIssueTransactionView, OnDestroy, OnInit {

  _innerHost = new ReplaySubject<ViewContainerRef>();
  @ViewChild('dynamicInner', { static: true, read: ViewContainerRef }) set innerHost(ref: ViewContainerRef){
    this._innerHost.next(ref);
  }

  commandCounter: number = 0;

  _subscriptions: Subscription[] = [];

  constructor(
    @Inject(STEP_FORM_GROUP) public formGroup: FormGroup,
    @Inject(TRANSACTION_STEP_PROVIDER) private service: ITransactionProvider,
    private _componentRefFactory: ComponentFactoryResolver
  ) { }

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this._subscriptions.push(combineLatest([this._innerHost, this.service.steps$]).subscribe(([ref, steps]) => this.renderComponents(ref, steps.filter(x => x.visibleInConclusion))))
  }

  renderComponents(ref: ViewContainerRef, steps: Step[]) {
    ref.clear();
    this.commandCounter = 0;
    for(var index = 0; index < steps.length; index++){
      let step = steps[index];
      let factory = this._componentRefFactory.resolveComponentFactory(GenericTransactionSummaryInnerViewComponent);
      ref.createComponent(factory, null, Injector.create({
        providers: [
          { provide: 'index', useValue: index },
          { provide: 'step', useValue: step }
        ]
      }));
    }
  }

}